import ReactGA from 'react-ga4';

let analyticsInitialized = false;

export const initializeAnalytics = (measurementId: string) => {
  if (!analyticsInitialized && measurementId) {
    ReactGA.initialize(measurementId);
    analyticsInitialized = true;

    // Send initial pageview
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }
};

// These functions are available for future use if needed
// export const trackPageView = (path: string) => {
//   if (analyticsInitialized) {
//     ReactGA.send({ hitType: 'pageview', page: path });
//   }
// };

// export const trackEvent = (category: string, action: string, label?: string) => {
//   if (analyticsInitialized) {
//     ReactGA.event({
//       category,
//       action,
//       label,
//     });
//   }
// };
